import { useTranslation } from 'react-i18next';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { DashboardOutlined, FileTextOutlined } from '@ant-design/icons';
import { Card, Col, Layout, Menu, Row, Typography } from 'antd';

import SessionStatsWidget from '../components/SessionStatsWidget';
import SessionFunnelWidget from '../components/SessionFunnelWidget';
import { useTokenAuth } from '../hooks/useTokenAuth';
import Sessions from './Sessions';

const { Header, Content, Sider } = Layout;
const { Title } = Typography;

const Dashboard: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useTokenAuth();

  // Show empty page if not authenticated
  if (!isAuthenticated) {
    return <div></div>;
  }

  const menuItems = [
    {
      key: '/',
      icon: <DashboardOutlined />,
      label: t('navigation.dashboard'),
    },
    {
      key: '/sessions',
      icon: <FileTextOutlined />,
      label: t('navigation.sessions'),
    },
  ];

  const handleMenuClick = ({ key }: { key: string }) => {
    // Preserve query parameters when navigating
    const searchParams = new URLSearchParams(location.search);
    const queryString = searchParams.toString();
    navigate(queryString ? `${key}?${queryString}` : key);
  };

  const DashboardHome = () => (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Card>
          <Title level={4}>{t('dashboard.welcome')}</Title>
          <p>This is the beginning of your admin dashboard for Conneo Print.</p>
        </Card>
      </Col>
      <Col span={24}>
        <SessionStatsWidget />
      </Col>
      <Col span={24}>
        <SessionFunnelWidget />
      </Col>
    </Row>
  );

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header
        style={{ background: '#fff', padding: '0 24px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
      >
        <Title level={3} style={{ margin: '16px 0', color: '#1890ff' }}>
          {t('dashboard.title')}
        </Title>
      </Header>
      <Layout>
        <Sider width={200} style={{ background: '#fff' }}>
          <Menu
            mode="inline"
            selectedKeys={[location.pathname]}
            items={menuItems}
            onClick={handleMenuClick}
            style={{ height: '100%', borderRight: 0 }}
          />
        </Sider>
        <Layout style={{ padding: '0 24px 24px' }}>
          <Content style={{ padding: 24, margin: 0, minHeight: 280 }}>
            <Routes>
              <Route path="/" element={<DashboardHome />} />
              <Route path="/sessions" element={<Sessions />} />
            </Routes>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default Dashboard;
